import React from "react";
import "../../styles/Home.css";
import Logo from "../../assets/logo.png";
import { Link } from "react-router-dom";
import { AiOutlineArrowRight } from "react-icons/ai";
import { BsArrowRight } from "react-icons/bs";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>AudioPedia</title>
      </Helmet>
      <div className="Header">
        <div className="Header_Logo">
          <Link to="/">
            <img
              src={Logo}
              alt="header_logo"
              className="intro_logo"
            />
          </Link>
        </div>
        <Link to="/language">
          <div className="header_forwardIcon_Res">
            <i className=" mui-forwardIcon_Res">
              <BsArrowRight style={{ marginTop: "5px" }} />
            </i>
          </div>
        </Link>
      </div>
    </>
  );
};

export default Home;
